import Component from '~/components/component';

export default class CollaboratorsGroups extends Component {
    constructor(...args) {
        super(...args);

        this._isMobile = (ENV.device == 'mobile' || ENV.device == 'tablet');
        this._dataCollaborators = ( typeof dataCollaborators != 'undefined' ) ? dataCollaborators : false;

        this._retrieveDOM();
    }

    _retrieveDOM() {
        this.dom.views = {};

        this.dom.views.collaborators = [].slice.call(this.dom.component.querySelectorAll('.js-collaborator'));

        this.dom.views.popin = {
            container : document.body.querySelector('.js-popin-portrait'),
            name: null,
            role: null,
            description: null,
            portrait: null,
            close: null
        };
        this.dom.views.popin.name = this.dom.views.popin.container.querySelector('.js-popin-name');
        this.dom.views.popin.role = this.dom.views.popin.container.querySelector('.js-popin-role');
        this.dom.views.popin.description = this.dom.views.popin.container.querySelector('.js-popin-description');
        this.dom.views.popin.portrait = this.dom.views.popin.container.querySelector('.js-popin-portrait');
        this.dom.views.popin.close = this.dom.views.popin.container.querySelector('.js-popin-close');
    }

    bind() {

        for( let i = 0, j = this.dom.views.collaborators.length; i < j; i++ ) {
            this.dom.views.collaborators[i].addEventListener('click', this._clickItemCollaborator.bind(this));
        }

        this.dom.views.popin.container.addEventListener('click', this._closePopinCollaborator.bind(this));
    }

    /**
     * Called when the user clicks the area of a collaborator
     */
    _clickItemCollaborator( event ) {

        let target = event.currentTarget;
        let indexItemCollaborator = this.dom.views.collaborators.indexOf( target );

        // Set datas in popin
        if( this._dataCollaborators ) {
            for( let i = 0, j = this._dataCollaborators.length; i < j; i++ ) {
                if( this._dataCollaborators[i]['id'] == indexItemCollaborator ) {
                    let name = this._dataCollaborators[i]['name'];
                    let role = this._dataCollaborators[i]['role'];
                    let description = this._dataCollaborators[i]['description'];
                    let portrait = this._dataCollaborators[i]['portrait'];

                    this._setNamePopin( name );
                    this._setRolePopin( role );
                    this._setDescriptionPopin( description );
                    this._setPortraitPopin( portrait );
                }
            }

            // Stop scroll window
            this._disableScrollWindow();

            // Hide menu
            this.emit( MANAGE_COLLABORATOR_EVENT.OPEN_POPIN );

            this.dom.views.popin.container.classList.add('show');
        }
    }

    /**
     * Called when the user clicks on the cross of closure of the popin
     */
    _closePopinCollaborator( event ) {

        // If user clicks apart from the popin or on the close button : hide popin / Otherwise, leave the popin displayed
        let isAllowToClose = ( closest(event.target, '.js-popin-portrait-container') ) && ( !event.target.classList.contains('js-popin-close') );
        if( typeof isAllowToClose != 'undefined' && isAllowToClose != false )
            return;

        this.dom.views.popin.container.classList.remove('show');

        // Empty the datas of the popin
        this._setNamePopin();
        this._setRolePopin();
        this._setDescriptionPopin();
        this._setPortraitPopin();

        // Put back the scroll of the window
        this._enableScrollWindow();

        // Show menu
        this.emit( MANAGE_COLLABORATOR_EVENT.CLOSE_POPIN );
    }

    /**
     * Disable scroll window
     */
    _disableScrollWindow() {
        this._currentScroll = window.pageYOffset;
        setTimeout(() => {
            document.body.classList.add('no-scroll');
        }, 600);
    }

    /**
     * Enable scroll window
     */
    _enableScrollWindow() {
        document.body.classList.remove('no-scroll');
        if( this._isMobile )
            TweenMax.set(window, { scrollTo: { y: this._currentScroll } });
    }

    /**
     * Setter the content "name" of the popin
     */
    _setNamePopin( value = '' ) {
        this.dom.views.popin.name.innerHTML = value;
    }

    /**
     * Setter the content "role" of the popin
     */
    _setRolePopin( value = '' ) {
        this.dom.views.popin.role.innerHTML = value;
    }

    /**
     * Setter the content "description" of the popin
     */
    _setDescriptionPopin( value = '' ) {
        this.dom.views.popin.description.innerHTML = value;
    }

    /**
     * Setter the content "image" of the popin
     */
    _setPortraitPopin( value = '' ) {
        this.dom.views.popin.portrait.setAttribute('src', value);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}

export const MANAGE_COLLABORATOR_EVENT = {
    'OPEN_POPIN' : '__mc_open_popin',
    'CLOSE_POPIN' : '__mc_close_popin'
}


// WEBPACK FOOTER //
// src/js/components/collaborators-groups/collaborators-groups.js